import { Text } from '@yes.technology/react-toolkit'
import {
  GradientBar,
  LegendContainer,
  LegendText,
  MapLegendContainer
} from './BrazilMap.styles'
import { MapLegendProps } from './BrazilMap.types'
import { setFormat } from './utils'
import { useTranslation } from 'react-i18n-lite'

const MapLegend = ({ title, data, format }: MapLegendProps) => {
  const { language: locale } = useTranslation()

  let minValue = data[0]?.value
  let maxValue = data[data.length - 1]?.value

  const minColor = data[0]?.color
  const maxColor = data[data.length - 1]?.color

  if (format) {
    minValue = setFormat(minValue, format, locale)
    maxValue = setFormat(maxValue, format, locale)
  }

  return (
    <>
      <MapLegendContainer>
        <Text variant='content-emphasis-03' as='h6'>
          {title}
        </Text>
        <LegendContainer>
          <GradientBar colorStart={minColor} colorEnd={maxColor} />
          <LegendText>
            <Text variant='content-emphasis-02' as='p'>
              {minValue}
            </Text>
            <Text variant='content-emphasis-02' as='p'>
              {maxValue}
            </Text>
          </LegendText>
        </LegendContainer>
      </MapLegendContainer>
    </>
  )
}

export default MapLegend
